import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { UploaderBlock } from '../../abstract/UploaderBlock.js';
import { ActivityBlock } from '../../abstract/ActivityBlock.js';
const L10N_PREFIX = 'src-type-';

/**
 * @typedef {{
 *   type: string;
 *   activity?: string;
 *   textKey?: string;
 *   icon?: string;
 *   activate?: () => boolean;
 *   activityParams?: Record<string, unknown>;
 * }} TConfig
 */

export class SourceBtn extends UploaderBlock {
  constructor() {
    super();
    _defineProperty(this, "couldBeCtxOwner", true);
    /** @type {string | undefined} */
    _defineProperty(this, "type", undefined);
    /**
     * @private
     * @type {Record<string, TConfig>}
     */
    _defineProperty(this, "_registeredTypes", {});
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      iconName: 'default'
    });
  }
  initTypes() {
    this.registerType({
      type: UploaderBlock.sourceTypes.LOCAL,
      activate: () => {
        this.openSystemDialog();
        return false;
      }
    });
    this.registerType({
      type: UploaderBlock.sourceTypes.URL,
      activity: ActivityBlock.activities.URL,
      textKey: 'from-url'
    });
    this.registerType({
      type: UploaderBlock.sourceTypes.CAMERA,
      activity: ActivityBlock.activities.CAMERA,
      activate: () => {
        const supportsCapture = 'capture' in document.createElement('input');
        if (supportsCapture) {
          this.openSystemDialog({
            captureCamera: true
          });
        }
        return !supportsCapture;
      }
    });
    this.registerType({
      type: 'draw',
      activity: ActivityBlock.activities.DRAW,
      icon: 'edit-draw'
    });
    for (let externalSourceType of Object.values(UploaderBlock.extSrcList)) {
      this.registerType({
        type: externalSourceType,
        activity: ActivityBlock.activities.EXTERNAL,
        activityParams: {
          externalSourceType: externalSourceType
        }
      });
    }
  }
  initCallback() {
    super.initCallback();
    this.initTypes();
    this.setAttribute('role', 'button');
    this.defineAccessor('type', /** @param {string} val */
    val => {
      if (!val) {
        return;
      }
      this.applyType(val);
    });
  }

  /** @param {TConfig} typeConfig */
  registerType(typeConfig) {
    this._registeredTypes[typeConfig.type] = typeConfig;
  }

  /** @param {string} type */
  getType(type) {
    return this._registeredTypes[type];
  }
  activate() {
    if (!this.type) {
      return;
    }
    const configType = this._registeredTypes[this.type];
    const {
      activity,
      activate,
      activityParams = {}
    } = configType;
    const showActivity = activate ? activate() : !!activity;
    showActivity && this.set$({
      '*currentActivityParams': activityParams,
      '*currentActivity': activity
    });
  }

  /** @param {string} type */
  applyType(type) {
    const configType = this._registeredTypes[type];
    if (!configType) {
      console.warn('Unsupported source type: ' + type);
      return;
    }
    const {
      textKey = type,
      icon = type
    } = configType;
    this.applyL10nKey('src-type', "".concat(L10N_PREFIX).concat(textKey));
    this.$.iconName = icon;
    this.onclick = () => {
      this.activate();
    };
  }
}
SourceBtn.template = /* HTML */"\n  <lr-icon set=\"@name: iconName\"></lr-icon>\n  <div class=\"txt\" l10n=\"src-type\"></div>\n";
SourceBtn.bindAttributes({
  // @ts-expect-error symbiote types bug
  type: null
});